app.service('maintenanceService', ['$rootScope', '$interval',
  'HttpAuth', 'apiHelper', '$location',
  function ($rootScope, $interval,
    HttpAuth, apiHelper, $location) {
    const service = this;
    const now = new Date().getTime();
    service.maintenanceStatusUrl = apiHelper.getApiUrl() +
      '/api/maintenance_window.json?ts=' + now;

    // RPR-6932. This probe must not raise anything user-facing: it runs at service construction,
    // before login, on every page, and a single unreachable tick is not something the user can act
    // on. But it must not be fully silent either - the failure it hides is that users never get
    // redirected into maintenance.9eac7a74.html during a real window, and during a real window the API is
    // usually down, which is exactly when this rejects. Silence there is indistinguishable from
    // "no window scheduled", so a broken probe would never be found.
    //
    // So: quiet through a blip, one Sentry event once it has been failing long enough to mean
    // something, re-armed on the next success. This mirrors phReportWrongUserRetryProblem in
    // portal_helper.js, which reports for the same reason.
    const PROBE_FAILURES_BEFORE_REPORT = 3;

    const reportProbeFailure = function (response) {
      service.consecutiveProbeFailures = (service.consecutiveProbeFailures || 0) + 1;
      if (service.consecutiveProbeFailures !== PROBE_FAILURES_BEFORE_REPORT) {
        return;
      }
      if (globalThis.Sentry) {
        globalThis.Sentry.captureMessage(
          'RPR-6932 maintenance probe failed ' + PROBE_FAILURES_BEFORE_REPORT +
            ' consecutive checks - maintenance redirect may not fire',
          {level: 'warning', extra: {status: response?.status, xhrStatus: response?.xhrStatus}}
        );
      }
    };

    // Exposed rather than private so the escalation above can be driven directly in a spec: the
    // only other ways in are service construction and the 30-second timer.
    service.checkForMaintenance = function () {
      // Two-argument form rather than a trailing .catch(): a trailing .catch() would also swallow
      // a TypeError thrown by fetchMaintenanceStatus's own success handler, which indexes
      // result.data[0], and that is a code bug that should keep reaching Sentry on its own.
      service.fetchMaintenanceStatus().then(
        function (result) {
          service.consecutiveProbeFailures = 0;
          if (service.is_maintenance_running) {
            window.location.href = '/maintenance.9eac7a74.html?end_datetime=' +
            new Date(service.maintenance_end_datetime).getTime();
          }
        },
        reportProbeFailure
      );
    };

    service.pollMaintenanceStatus = function () {
      // Started from both login_dashboard and common_app_controller, and Angular does not cancel an
      // $interval when the scope that created it is destroyed - so without this guard those two
      // poll in parallel, and every rebuild of either controller adds another poller on top.
      if (service.pollHandle) {
        return service.pollHandle;
      }
      service.pollHandle = $interval(function () {
        service.checkForMaintenance();
      }, 30000);
      return service.pollHandle;
    };

    service.stopPollingMaintenanceStatus = function () {
      if (service.pollHandle) {
        $interval.cancel(service.pollHandle);
        service.pollHandle = null;
      }
    };

    service.fetchMaintenanceStatus = function () {
      return HttpAuth.get(service.maintenanceStatusUrl).then(
        function (result) {
          if (result.data.length === 1) {
            service.is_maintenance_running = result.data[0].maintenance_started;
            service.maintenance_start_datetime = new Date(result.data[0].start_datetime);
            service.maintenance_end_datetime = new Date(result.data[0].end_datetime);
            service.banner_display_duration_hours = result.data[0].banner_display_duration_hours;
          }
        }
      );
    };

    service.checkForMaintenance();

  }]);